import React, {useState, useEffect, useRef, useCallback} from "react";
import HeaderPage from "../../../../palette/HeaderPage";
import './my-company.css'
import VerticalSpace from "../../../../palette/VerticalSpace";
import Form, {
    ButtonItem,
    GroupItem,
    SimpleItem,
    RequiredRule,
    PatternRule,
    AsyncRule
} from 'devextreme-react/form';
import {inject, observer} from "mobx-react";
import {db, storage, auth} from '../../../../firebase/Firebase'
import {useSnackbar} from 'notistack';
import {cities} from "../../../../utils/Utils";
import {makeStyles} from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import {Layout, LayoutChild} from "../../../../palette/Palette";
import FileUploader from 'devextreme-react/file-uploader';
import {ProgressBar} from 'react-bootstrap'
import Alerts from "../../../../palette/Alerts";
import {ErrorMessage, NotiStackInfo} from "../../../../palette/NotiStackInfo";
import {buttonSuccess} from "../../../../utils/ComponentsSetting";
import {Element} from 'react-scroll'
import {scrollTo} from "../../../../utils/Scroll";
import {Animated} from "react-animated-css";
import {Tooltip} from 'devextreme-react/tooltip';
import {asyncPhoneValidation,} from "../../../../utils/Validations";

const companyData = {
    legalRepresentative: '',
    RUC: '',
    celPhone: '',
    phone: '',
    contactPerson: '',
    contactPhone: '',
    country: '',
    city: '',
    address: '',
    IVA: null,
    web: '',
    logo: '',
    inverse: 'white',
    color: 'black'
};

const countries = ['Ecuador']

const useMountedState = () => {
    const mountedRef = useRef(false)
    const isMounted = useCallback(() => mountedRef.current, [])

    useEffect(() => {
        mountedRef.current = true

        return () => {
            mountedRef.current = false
        }
    }, [])

    return isMounted
}

function SettingsCompanyData(props) {

    const {DataStore} = props
    const {companyName, idCompany, companyMail} = DataStore

    const [submitButton, setSubmitButton] = useState({
        ...buttonSuccess, text: 'Guardar datos'
    })
    const [company, setCompany] = useState({})
    const [imageAsUrl, setImageAsUrl] = useState(null)
    const [filePhoto, setFilePhoto] = useState('No se ha seleccionado ninguna imagen');
    const [progressImage, setProgressImage] = useState(0);
    const [isImage, setIsImage] = useState(true)
    const [uploadFinished, setUploadFinished] = useState(false)
    const [noImage, setNoImage] = useState(false)
    const [load, setLoad] = useState(false)
    const [defaultVisible, setDefaultVisible] = useState(false)
    const [trigger, setTrigger] = useState(false)

    const isMounted = useMountedState()

    useEffect(() => {
        if (isMounted()) {
            db.collection(companyName).doc(idCompany).get().then(doc => {
                if (doc.exists) {
                    setImageAsUrl(doc.data().logo)
                    setCompany(doc.data())
                    setLoad(true)
                    setSubmitButton({...submitButton, icon: 'far fa-edit', disabled: false, text: 'Actualizar'})
                } else {
                    setLoad(true)
                    setCompany(companyData)
                }
            })
        }
    }, [companyName, idCompany, isMounted, trigger])

    const classes = useStyles();
    const {enqueueSnackbar} = useSnackbar();

    const companyChar = companyName.charAt(0)

    const textToolTip = 'Tamaño recomendado ' +
        '\n ' +
        '180x180, en formato .png ' +
        '\n ' +
        'transparente'

    const avatarRender = () => {
        return (
            <div className={classes.root}>
                {imageAsUrl ? <Avatar alt="" src={imageAsUrl} className={classes.large}/> :
                    <Avatar alt="" className={classes.large}>{companyChar}</Avatar>
                }
            </div>
        )
    }
    const uploadPhoto = () => {
        return (
            <Layout color={'transparent'}>
                <Element name="top-element" className="element"/>
                <Layout color={'transparent'} center positionL>
                    <LayoutChild width="auto" row>
                        <FileUploader multiple={false} accept={'*'} uploadMode={'instantly'} showFileList={false}
                                      allowedFileExtensions={['.jpg', '.jpeg', '.gif', '.png']}
                                      inputAttr={{id: 'upload-buttons'}} selectButtonText={'Seleccionar imagen'}
                                      onValueChanged={onSelectedImageFilesChanged} elementAttr={{id: 'upload-buttons'}}
                                      labelText={filePhoto}/>
                        <i id="info" className="fas fa-info-circle" style={{marginTop: 30, cursor: 'pointer'}}
                           onMouseEnter={() => setDefaultVisible(true)}
                           onMouseLeave={() => setDefaultVisible(false)}>
                            <Tooltip
                                target="#info"
                                visible={defaultVisible}
                                closeOnOutsideClick={false}
                            >
                                <div>{textToolTip}</div>
                            </Tooltip>
                        </i>
                    </LayoutChild>

                </Layout>
                {
                    progressImage > 0 &&
                    <Layout color={'#FFF'}>
                        <div style={{width: '100%', margin: 'auto'}}>
                            <ProgressBar now={progressImage} label={`${progressImage}%`}/>
                        </div>
                    </Layout>
                }
                <VerticalSpace space={10}/>
                {
                    !isImage && <Alerts severity={'warning'} body={'Solo se permiten imágenes'}/>
                }
                {
                    uploadFinished && <Alerts severity={'success'} body={'Carga completada'}/>
                }
                <VerticalSpace space={5}/>
                {
                    noImage && <Alerts severity={'error'} body={'Seleccione un logo para la empresa'}/>
                }
            </Layout>
        );
    };
    const onSelectedImageFilesChanged = (e) => {

        const arrayExt = ['jpg', 'jpeg', 'png'];
        const extension = e.value[0].name.split('.').pop();
        const found = arrayExt.find(element => element === extension);

        if (found) {
            setIsImage(true)

            const picName = `${e.value[0].name}`;

            const bucketPath = `${companyName}/profile/${picName}`

            const storageRef = storage.ref(bucketPath)
            const task = storageRef.put(e.value[0])

            task.on('state_changed', (snapshot) => {
                let percentage = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                setProgressImage(percentage)
            }, () => {
                NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
            }, () => {

                storage.ref(`${companyName}/profile/`).child(picName).getDownloadURL()
                    .then(async fireBaseUrl => {

                        setImageAsUrl(fireBaseUrl)
                        DataStore.getImageAsUrl(fireBaseUrl)

                        let user = auth.currentUser;
                        await user.updateProfile({
                            photoURL: fireBaseUrl
                        }).then(() => {
                            setUploadFinished(true)
                            setNoImage(false)
                            setProgressImage(0)
                            scrollTo('bottom-element')
                        }).catch(() => {
                            NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
                        })
                    }).catch(() => {
                    NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
                })
            })
        } else {
            setIsImage(false)
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (imageAsUrl) {
            const newDataCompany = {...company, logo: imageAsUrl, finished: true};

            setSubmitButton({...submitButton, icon: 'fa fa-spinner fa-spi', disabled: true, text: 'Guardando...'})

            await db.collection(companyName).doc(idCompany).set(newDataCompany)
                .then(async () => {
                    await db.collection('Users').doc(idCompany).update({
                        finished: true
                    }).then(() => {
                        setTrigger(!trigger)
                        NotiStackInfo('Los datos de la empresa han sido guardados exitosamente', 'success', enqueueSnackbar)
                        setSubmitButton({...buttonSuccess, text: 'Guardar datos', disabled: false})
                        scrollTo('top-element')
                    })
                }).catch(() => {
                    setSubmitButton({...buttonSuccess, text: 'Guardar datos', disabled: false})
                    NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
                })
        } else {
            setNoImage(true)
            scrollTo('top-element')
        }
    }

    return (
        <>
            <Animated animationIn="fadeIn" animationOut="slideOutUp" isVisible={true}>
                <VerticalSpace space={30}/>
                <div className="company-container">
                    <HeaderPage icon={'far fa-building'} text={'Datos de la empresa'} load={load}
                                textLoad={'Cargando...'}/>

                    <div style={{padding: 10, marginTop: 20}}>
                        <form action="" onSubmit={handleSubmit}>
                            <Form
                                formData={company}
                                readOnly={false}
                                showColonAfterLabel={true}
                                validationGroup="companyData"
                            >
                                <GroupItem caption="Logo" colCount={2} colSpan={2}>
                                    <SimpleItem render={avatarRender}/>
                                    <SimpleItem render={uploadPhoto}/>
                                </GroupItem>
                                <GroupItem colCount={2} colSpan={2} caption="Datos comerciales"
                                           alignItemLabels={'left'}>
                                    <SimpleItem dataField="legalRepresentative" label={{text: 'Nombre comercial'}}
                                                editorOptions={{value: companyName, disabled: true}}/>
                                    <SimpleItem dataField="legalRepresentative" label={{text: 'Razón social'}}
                                                editorOptions={{maxLength: 50}}>
                                        <RequiredRule message="La razon social es requerida"/>
                                    </SimpleItem>
                                    <SimpleItem dataField="RUC" label={{text: 'Identificador tributario'}}
                                                editorOptions={{maxLength: 15}}>
                                        <RequiredRule message="Ingrese el identificador tributario."/>
                                        <PatternRule message="Ingresar solo números"
                                                     pattern={/^[0-9]+$/}/>
                                    </SimpleItem>
                                    <SimpleItem dataField="IVA" label={{text: 'IVA'}} editorType={'dxNumberBox'}
                                                editorOptions={{format: "#0%", maxLength: 2, min: 0, max: 1}}>
                                        <RequiredRule message="Ingrese el valor del IVA."/>
                                    </SimpleItem>

                                </GroupItem>
                                <GroupItem colCount={2} colSpan={2} caption="Ubicación">
                                    <SimpleItem dataField="country" label={{text: 'País'}} editorType="dxSelectBox"
                                                editorOptions={{
                                                    items: countries,
                                                    searchEnabled: true,
                                                    value: company.country,
                                                    placeholder: 'Seleccionar...'
                                                }}>
                                        <RequiredRule message="Seleccione el pais"/>
                                    </SimpleItem>

                                    <SimpleItem dataField="city" label={{text: 'Ciudad'}} editorType="dxSelectBox"
                                                editorOptions={{
                                                    items: cities,
                                                    searchEnabled: true,
                                                    placeholder: 'Seleccionar...',
                                                }}>
                                        <RequiredRule message="Seleccione la ciudad"/>
                                    </SimpleItem>

                                    <SimpleItem dataField="address" label={{text: 'Dirección'}}
                                                editorOptions={{maxLength: 60}}>
                                        <RequiredRule message="Ingrese la dirección"/>
                                    </SimpleItem>

                                </GroupItem>
                                <GroupItem colCount={2} colSpan={2} caption="Contactos">
                                    <SimpleItem dataField="phone" label={{text: 'Teléfono'}}
                                                editorOptions={{maxLength: 10, min: 9}}>
                                        <RequiredRule message="Ingrese el número de teléfono."/>
                                        <PatternRule message="Ingresar solo números"
                                                     pattern={/^[0-9]+$/}/>
                                        <AsyncRule
                                            message="Formato incorrecto"
                                            validationCallback={asyncPhoneValidation} />
                                    </SimpleItem>

                                    <SimpleItem dataField="celPhone" label={{text: 'Celular'}}
                                                editorOptions={{maxLength: 10, min: 9}}>
                                        <RequiredRule message="Ingrese el número de celular."/>
                                        <PatternRule message="Ingresar solo números"
                                                     pattern={/^[0-9]+$/}/>
                                        <AsyncRule
                                            message="Formato incorrecto"
                                            validationCallback={asyncPhoneValidation} />
                                    </SimpleItem>


                                    <SimpleItem dataField="email" label={{text: 'Correo electrónico'}}
                                                editorOptions={{value: companyMail, disabled: true}}/>

                                    <SimpleItem dataField="web" label={{text: 'Web'}}/>

                                    <SimpleItem dataField="contactPerson" label={{text: 'Persona de contacto.'}}
                                                editorOptions={{maxLength: 50}}>
                                        <RequiredRule message="Ingrese la persona de contacto."/>
                                    </SimpleItem>

                                    <SimpleItem dataField="contactPhone" label={{text: 'Teléfono de contacto'}}
                                                editorOptions={{maxLength: 10, min: 9}}>
                                       {/* <StringLengthRule min={9} message={'dasdsd'} max={10}/>*/}
                                        <PatternRule message="Ingresar solo números" pattern={/^[0-9]+$/}/>
                                        <RequiredRule message="Ingrese el número de celular."/>
                                    </SimpleItem>
                                </GroupItem>
                                <GroupItem colCount={2} colSpan={2} caption="Paleta de colores app">
                                    <SimpleItem dataField="inverse" label={{text: 'Color del texto'}}
                                                editorType={'dxColorBox'}
                                                editorOptions={{value: company.inverse, applyValueMode: "instantly"}}>
                                        <RequiredRule message="Escoja el color del texto en para la app movil."/>
                                    </SimpleItem>

                                    <SimpleItem dataField="color" label={{text: 'Color app'}} editorType={'dxColorBox'}
                                                editorOptions={{value: company.color, applyValueMode: "instantly"}}>
                                        <RequiredRule message="Escoja un color"/>
                                    </SimpleItem>
                                </GroupItem>
                                <ButtonItem horizontalAlignment="right" buttonOptions={submitButton}/>
                            </Form>
                        </form>
                    </div>
                </div>
                <Element name="bottom-element" className="element"/>
            </Animated>
            <VerticalSpace space={15}/>
        </>
    )
}

export default inject('DataStore')(observer(SettingsCompanyData));

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        '& > *': {
            margin: theme.spacing(1),
        },
    },
    large: {
        width: theme.spacing(15),
        height: theme.spacing(15),
    },
}));
